import { Component } from '@angular/core';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrl: './not-found.component.css',
    standalone: false
})
export class NotFoundComponent {
  constructor() {}
}
